export const ActionTypes = {
  SET_PARTNER_SETTING: 'SET_PARTNER_SETTING'
};
